import clsx from "clsx";

import { Icon, IconsType } from "@web-app/components";

export type SidebarMode = "list" | "table";

export interface SidebarTabsProps {
  className?: string;
  onSelectTab: (tabName: SidebarMode) => void;
  selectedTab: SidebarMode;
}

const SidebarTabs = ({
  className,
  onSelectTab,
  selectedTab,
}: SidebarTabsProps) => {
  const tabs: { icon: IconsType; name: SidebarMode }[] = [
    { icon: "list", name: "list" },
    { icon: "table", name: "table" },
  ];

  return (
    <nav className="flex gap-1" aria-label="Tabs">
      {tabs.map((tab) => (
        <span
          key={tab.name}
          className={clsx(
            tab.name === "table" && "hidden lg:flex",
            tab.name === selectedTab
              ? "bg-gray-200 text-gray-700 hover:bg-gray-700 hover:text-gray-300"
              : "text-gray-700 hover:bg-gray-700 hover:text-gray-300",
            "flex h-[32px] w-[32px] p-[6px] cursor-pointer items-center rounded-md   text-xs font-normal transition ease-in",
            className,
          )}
          onClick={() => onSelectTab(tab.name)}
        >
          <Icon name={tab.icon} className="h-5" />
        </span>
      ))}
    </nav>
  );
};

export default SidebarTabs;
